import { Outlet, ScrollRestoration } from "react-router-dom";
import { AuthenticationProvider } from "./authentication/context/AuthenticationProvider";
import { Helmet } from "react-helmet";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Toastify.css";
import { ServiceWorkerUpdateProvider } from "./core/service-worker/ServiceWorkerUpdateContext";
import { church } from "./core/church/church";
import { ChurchConfigurationProvider } from "./core/church/ChurchConfigurationProvider";

const AppContent = () => {
    const hubName = `${church.name} ${church.appName}`;

    return (
        <>
            <Helmet titleTemplate={`%s ― ${hubName}`} defaultTitle={hubName} />

            <ToastContainer position="bottom-right" stacked />

            <ScrollRestoration getKey={(location) => location.pathname} />

            <AuthenticationProvider>
                <ChurchConfigurationProvider>
                    <Outlet />
                </ChurchConfigurationProvider>
            </AuthenticationProvider>
        </>
    );
};

export const App = () => (
    <ServiceWorkerUpdateProvider>
        <AppContent />
    </ServiceWorkerUpdateProvider>
);
